<kendo-tabstrip class="nav-bordered" id="tabs" name="tabs" (tabSelect)="selecionouTipoDeEstoque($event)">
  <kendo-tabstrip-tab [id]="tipo.id" [title]="tipo.nome" *ngFor="let tipo of produtosPorEstoque; index as i"
                      [selected]="tipo.nome === estoqueSelecionado" [disabled]="carregando">
    <ng-template kendoTabTitle>
        {{tipo.nome}}

      <span class="badge  rounded-circle noti-icon-badge" *ngIf="tipo.nome === ReposicaoEstoque"
            [ngClass]="{'badge-danger':  resumoEstoque.totalAlertas > 0,   'badge-light': ! resumoEstoque.totalAlertas }">
                     {{resumoEstoque.totalAlertas}}</span>

    </ng-template>
    <ng-template kendoTabContent>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

<div class="card card-sticky" [hidden]="abaAlertaEstoque()" >
  <div class="" style="width: 100%;">
    <div class="row">
      <div class="col-6 col-sm-auto">
        <div class="form-group">
          <label>Busca de Produtos</label>
          <div>
          <input kendoTextBox placeholder="Busque por nome, categoria , ordem ou valor" class="form-control busca"
                 name="txtFiltro" [(ngModel)]="filtro.texto"
           appAutoFocus kendoTextBox (input)="onFilter($event)"/>
          </div>
        </div>
      </div>

      <div class="col-6 col-sm-auto">
        <div class="form-group">
          <label>Categoria</label>
          <div>
            <kendo-combobox id="cboCategorias" class="form-control" [data]="categoriasDoCatalogo" style="width: 250px"
                            textField="nome" valueField="id" [(ngModel)]="categoriaSelecionada" [allowCustom]="false"
                            (selectionChange)="busqueProdutos()">
            </kendo-combobox>
          </div>
        </div>

      </div>

      <div class="col-6 col-sm-auto" *ngIf="!abaProdutosExternos()">
        <div class="form-group">
          <label>Disponibilidade</label>
          <div>
          <kendo-multiselect id="cboDisponibilidade" class="form-control" [data]="disponibilidades" style="width: 250px"
                             textField="descricao" valueField="id"   [(ngModel)]="filtroDisponibilidades"
                             [allowCustom]="false"
                             (valueChange)="busqueProdutos()"
          >
          </kendo-multiselect>
          </div>
        </div>
      </div>

      <div class="col-6 col-sm-auto" *ngIf="!abaProdutosExternos()">

        <div class="input-group mt-4">
          <input  name="primeiraCompra" id='primeiraCompra' kendoCheckBox    class="k-checkbox  " type="checkbox" (ngModelChange)="busqueProdutos()"
                  [(ngModel)]="filtro.semCodigoPdv"/>
          <label  class="k-checkbox-label">       Sem codigo de PDV</label>


        </div>

      </div>

      <div class="col-6 col-sm-auto" *ngIf="possuiModuloFiscal && !abaProdutosExternos()">

        <div class="input-group mt-4">
          <input  name="semDadosFiscais" id='semDadosFiscais' kendoCheckBox    class="k-checkbox  " type="checkbox" (ngModelChange)="busqueProdutos()"
                  [(ngModel)]="filtro.semDadosFiscais"/>
          <label  class="k-checkbox-label">       Sem dados fiscais</label>


        </div>

      </div>

      <div class="col-6 col-sm-auto" *ngIf="empresa && empresa.rede === 'chinainbox' && !abaProdutosExternos()" >

        <div class="input-group mt-4">
          <input  name="naoSincronizados" id='naoSincronizados' kendoCheckBox    class="k-checkbox  " type="checkbox" (ngModelChange)="busqueProdutos()"
                  [(ngModel)]="filtro.naoSincronizados"/>
          <label  class="k-checkbox-label"> Produtos não sincronizados</label>


        </div>

      </div>
    </div>

    <div class="row botoes">
      <div  kendoTooltip class="col-12 product-actions">
        <div class="product-actions__primary">
        <button  [disabled]="!podeEditarProdutos"
          [title]="podeEditarProdutos ? 'Criar um novo produto' : 'Criar produtos não é permitido em cardápios compartilhados'"
          class="btn btn-success product-action-btn product-action-btn--new" (click)="novoProduto()"
                  >
            <i class="fe-plus"></i>
            <span class="hidden-phone ">
          Novo Produto
          </span>


        </button>


        <button  [disabled]="!podeEditarProdutos" *ngIf="empresa?.integracaoPedidoFidelidade?.resgatarBrinde"
                 [title]="podeEditarProdutos ? 'Criar um novo brinde' : 'Criar bridnes não é permitido em cardápios compartilhados'"
                 class="btn btn-warning product-action-btn" (click)="novoProduto(true)"
        >
          <i class="fe-plus"></i>
          <span class="hidden-phone ">
          Novo Brinde
          </span>


        </button>


        <button [disabled]="!podeEditarProdutos"
                [title]="podeEditarProdutos ? 'Ordenar e criar categorias' : 'Edição não permitida em cardápios compartilhados'"
                class="btn btn-primary product-action-btn product-action-btn--categories" (click)="ordenarCategorias()"   >
          <i class="fe-list mr-1"></i>

          <span class="hidden-phone ml-1">
            Categorias
          </span>
        </button>

        <button [disabled]="!podeAlterarDisponibilidade()"
                [title]="podeAlterarDisponibilidade() ? 'Selecionar produtos para alterar disponibilidade' : 'Disponibilidade bloqueada neste catálogo'"
                class="btn btn-light product-action-btn product-action-btn--bulk"
                [ngClass]="{'is-active': selecionandoProdutosLote}"
                (click)="toggleSelecaoProdutosLote()"
                *ngIf="!abaProdutosExternos()">
          <i class="fas" [ngClass]="selecionandoProdutosLote ? 'fa-times' : 'fa-check-square'"></i>
          <span class="hidden-phone ml-1">
            {{selecionandoProdutosLote ? 'Cancelar seleção' : 'Selecionar produtos'}}
          </span>
        </button>

        <button type="button"
                [disabled]="!possuiProdutosComComplementosVisiveis"
                [title]="possuiProdutosComComplementosVisiveis ? labelModoComplementosExpandido + ' dos produtos visíveis' : 'Nenhum produto visível possui adicionais'"
                class="btn btn-light product-action-btn product-action-btn--expand"
                [ngClass]="{'is-active': todosComplementosVisiveisAbertos}"
                (click)="toggleModoComplementosExpandido()">
          <i class="fas" [ngClass]="iconeModoComplementosExpandido"></i>
          <span class="hidden-phone ml-1">
            {{labelModoComplementosExpandido}}
          </span>
        </button>

        <button class="btn btn-blue product-action-btn product-action-btn--template" (click)="abrirCadTemplatePizza()" *ngIf="empresa && empresa.pizzaria">
          <i class="fe-pie-chart"></i>
          <span class="hidden-phone">
              Template Pizzas
          </span>
        </button>
        </div>

        <div class="dropdown product-actions__tools">
          <button class="btn btn-light k-grid-edit-command dropdown-toggle product-action-btn product-action-btn--tools" type="button"
                  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-cog mr-1"></i>Ferramentas
          </button>

          <div class="dropdown-menu dropdown-menu-right product-tools-menu" aria-labelledby="dropdownMenuButton">
            <h6 class="dropdown-header">Organização</h6>
            <button type="button"
                    class="dropdown-item cpointer"
                    [title]="podeEditarProdutos ? 'Coloca os produtos em ordem alfabética' : 'Não é permitido reordenar cardápios compartilhados' "
                    (click)="confirmeReornedarProdutos()"
                    [disabled]="ordenando || !podeEditarProdutos">
              <i class="fa fa-random mr-2" *ngIf="!ordenando"></i>
              <i class="k-icon k-i-loading mr-2" *ngIf="ordenando"></i>
              Ordenar por nome
            </button>

            <ng-container *ngIf="podeEditarProdutos || usuario.admin">
              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header">Importação</h6>
              <ng-container *ngIf="getNomeRede() && !catalogo?.compartilhado && usuario.admin">
                <a class="dropdown-item cpointer"  (click)="abrirImportarCatalogoEmpresaRede()" >
                  <i class="fa fa-sitemap mr-2"></i>
                  Importar de outra loja   </a>

              </ng-container>
              <ng-container *ngIf="empresa?.modeloCatalogoDaRede">
                <a class="dropdown-item cpointer"  (click)="importarProdutosCatalogoModelo()" >
                  <i class="fa fa-sitemap mr-2"></i>
                  Sincronizar com <b>"{{empresa?.modeloCatalogoDaRede.catalogo.nome}}"</b>  </a>
              </ng-container>


              <ng-container *ngIf="empresa?.integracaoOpendelivery?.ativa">
                <a class="dropdown-item cpointer" (click)="importarOpenDelivery()" >
                  <i class="fas fa-file-upload mr-2"></i>
                  Importar {{empresa.integracaoOpendelivery.merchantName}}</a>
              </ng-container>

              <ng-container *ngIf="sincronizarComParceiros()">
                <a class="dropdown-item cpointer" (click)="sincronizarPrecos()" >
                  <i class="fas fa-dollar-sign mr-2"></i>Preços</a>
                <a class="dropdown-item cpointer"  (click)="sincronizarEstoque()">
                  <i class="fas fa-toggle-on mr-2"></i>Disponibilidade</a>
                <a class="dropdown-item cpointer"  (click)="importarProdutosERP()" >
                  <i class="fas fa-file-upload mr-2"></i>Novos Produtos</a>
                <a class="dropdown-item cpointer"  (click)="importarProdutoCodigoERP()">
                  <i class="fas fa-search mr-2"></i>Sincronizar Produto por Código</a>
                <a class="dropdown-item cpointer"  (click)="exibaModalProdutosIndisponiveis($event)">
                  <i class="fas fa-eye-slash mr-2"></i>Ver Produtos Indisponiveis</a>


                <ng-container *ngIf="empresa.integracaoDelivery?.unidadeGendai">
                  <a class="dropdown-item cpointer"  (click)="importarProdutosChinna()" >
                    <i class="fas fa-globe mr-2"></i>Importar site gendai</a>
                </ng-container>
              </ng-container>

              <a class="dropdown-item cpointer" (click)="importarDoIfoodOficial()"
                 *ngIf="empresa.integracoesIfood?.length"><i class="fas fa-file-upload mr-2"></i>Importar do IFood </a>
              <a class="dropdown-item cpointer" (click)="importarDeSistemaExterno()">
                <i class="fas fa-file-upload mr-2"></i>Importar de Sistema Externo</a>
              <div class="dropdown-divider"></div>

              <h6 class="dropdown-header">PDV</h6>
              <a class="dropdown-item cpointer"
                 (click)="abrirImportadorCodigosPdvEmLote()"
                 title="Baixar planilha, preencher códigos PDV e importar em lote">
                <i class="fas fa-barcode mr-2"></i>Códigos PDV em lote
              </a>

              <div class="dropdown-divider"></div>
              <h6 class="dropdown-header">Arquivo</h6>
              <a class="dropdown-item cpointer" (click)="importarDeArquivoCSV()" >
                <i class="fas fa-file-csv mr-2"></i>Importar de um CSV</a>
              <a class="dropdown-item cpointer" (click)="importarDeArquivoPrecosCSV()" >
                <i class="fas fa-file-csv mr-2"></i>Preços CSV</a>
            </ng-container>

            <div class="dropdown-divider"></div>
            <h6 class="dropdown-header">Exportação</h6>
            <a class="dropdown-item cpointer" (click)="downloadCardapioPDF()" >
              <i class="fas fa-file-pdf mr-2"></i>Cardápio em PDF
            </a>
            <a class="dropdown-item cpointer"  kendoTooltip title="download produtos" (click)="abraModalExportarProdutos()"  >
              <i class="fa fa-download mr-2"></i>Cardápio em CSV
            </a>

          </div>
        </div>
      </div>
    </div>

    <div class="bulk-availability-bar" *ngIf="selecionandoProdutosLote && !abaProdutosExternos()">
      <div class="bulk-availability-bar__info">
        <label class="bulk-availability-check">
          <input type="checkbox"
                 [checked]="todosProdutosVisiveisSelecionados()"
                 (change)="toggleTodosProdutosVisiveis($event)">
          <span>Selecionar página</span>
        </label>
        <strong>{{totalProdutosSelecionadosLote}} selecionado(s)</strong>
      </div>

      <div class="bulk-availability-bar__actions">
        <button type="button"
                class="btn btn-sm btn-primary"
                [disabled]="!totalProdutosSelecionadosLote"
                (click)="abraDisponibilidadeProdutosSelecionados()">
          <i class="far fa-clock mr-1"></i>
          Disponibilidade
        </button>
        <button type="button"
                class="btn btn-sm"
                [ngClass]="pausandoProdutosLote ? 'btn-warning' : 'btn-success'"
                [disabled]="!totalProdutosSelecionadosLote || !podeAlterarDisponibilidade() || processandoPausaProdutosLote"
                (click)="alterePausaProdutosSelecionadosLote()">
          <span class="k-icon k-i-loading mr-1" *ngIf="processandoPausaProdutosLote"></span>
          <i class="far mr-1" [ngClass]="iconePausaProdutosLote" *ngIf="!processandoPausaProdutosLote"></i>
          {{labelPausaProdutosLote}}
        </button>
        <button type="button"
                class="btn btn-sm btn-outline-danger"
                [disabled]="!totalProdutosSelecionadosLote || !podeEditarProdutos"
                [title]="podeEditarProdutos ? 'Excluir produtos selecionados' : 'Sem permissão para excluir produtos'"
                (click)="abraRemocaoProdutosSelecionados()">
          <i class="far fa-trash-alt mr-1"></i>
          Excluir
        </button>
        <button type="button"
                class="btn btn-sm btn-light"
                [disabled]="!totalProdutosSelecionadosLote"
                (click)="limpeSelecaoProdutosLote()">
          Limpar
        </button>
      </div>
    </div>

  </div>
</div>

<div  class="search-results" [hidden]="abaAlertaEstoque()">
  <div *ngIf="carregando" style="posfition: fixed;background: rgba(255, 255, 255, 0.2  );top: 0px;left: 0px;width: 100%;height: 100%;z-index: 99999">
  <div class="k-i-loading ml-1 mr-1 centralizado"
       style="font-size: 40px;height: 90px; position: absolute; top: 50%; left: 45%;" ></div>
  </div>

  <div class="card" *ngFor="let categoria of categorias">
    <div class="categoria">
      <h4>
        {{categoria.nome}}

        <ng-container *ngIf="categoria.id">
          <button class="btn btn-sm btn-danger ml-3" (click)="pausarCategoria(categoria)" *ngIf="categoria.disponivel && !abaProdutosExternos()"
                  [disabled]="processando || (!podeEditarProdutos && !catalogo.disponibilidadePorEmpresa)">
            <i class="far fa-pause-circle" kendoTooltip title="Parar Temporariamente a Venda dos Produtos da Categoria"></i>&nbsp;Parar Vendas
          </button>
          <button class="btn btn-sm btn-primary ml-3" (click)="ativarCategoria(categoria)" *ngIf="!categoria.disponivel && !abaProdutosExternos()"
                  [disabled]="processando || (!podeEditarProdutos && !catalogo.disponibilidadePorEmpresa)">
            <i class="far fa-play-circle" kendoTooltip title="Ativar a venda dos produtos da categoria"></i>&nbsp;Ativar Vendas
          </button>

          <button class="btn btn-sm btn-outline-secondary ml-2"
                  (click)="abraDisponibilidadeCategoria(categoria)"
                  *ngIf="categoria.id > 0 && !abaProdutosExternos()"
                  [disabled]="processando || !podeAlterarDisponibilidade()">
            <i class="far fa-clock" kendoTooltip title="Alterar disponibilidade dos produtos desta categoria"></i>&nbsp;Disponibilidade
          </button>

          <div class="alert alert-warning ml-2 font-13 mb-0 d-inline-block" *ngIf="!categoria.disponivel">
            <i>A venda de produtos desta categoria desativada</i>
          </div>
        </ng-container>
      </h4>
    </div>
    <kendo-grid
      (edit)="editarProduto($event)"
      (remove)="abraDialogRemoverProduto($event)"
      [data]="produtosPorCategoria[categoria.id]"
      [kendoGridExpandDetailsBy]="expandDetailsBy"
      [class]="'gridProdutos'"
      [(expandedDetailKeys)]="chaves"
      [style.width]="largura"
      [scrollable]="'scrollable'">
      <kendo-grid-messages
        pagerPage="Página"
        pagerOf="de"
        pagerItems="itens"
        noRecords="Sem produtos"
        loading="Carregando"
        pagerItemsPerPage="ítems por página"
      >
      </kendo-grid-messages>
      <kendo-grid-column title="" [width]="48" *ngIf="selecionandoProdutosLote">
        <ng-template kendoGridHeaderTemplate>
          <input type="checkbox"
                 class="bulk-grid-check"
                 [checked]="todosProdutosCategoriaSelecionados(categoria)"
                 (change)="toggleProdutosCategoria(categoria, $event)">
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <input type="checkbox"
                 class="bulk-grid-check"
                 [checked]="produtoEstaSelecionado(dataItem)"
                 (click)="$event.stopPropagation()"
                 (change)="toggleProdutoLote(dataItem, $event)">
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Ordem" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem  let-rowIndex="rowIndex">
          <div  class="ordem" >

            <kendo-dropdownbutton class="btn btn-block btn-light"
                    [ngClass]="{ 'desabilitado': trocandoOrdem  }" [hidden]="temFiltro()" [data]="opcoesSubir"
                                  (itemClick)="clicouSubir(dataItem, rowIndex, categoria, $event)">
              <i class="fas fa-chevron-up   cpointer"    ></i>
            </kendo-dropdownbutton>


            <span class="d-block font-16" [ngClass]="{'text-center': !filtro.texto, 'text-left ml-2': filtro.texto}">{{dataItem.ordem}}</span>

            <kendo-dropdownbutton class="btn btn-block btn-light"
                    [ngClass]="{ 'desabilitado': trocandoOrdem  }" [hidden]="temFiltro()" [data]="opcoesDescer"
                                  (itemClick)="clicouDescer(dataItem, rowIndex, categoria, $event)">
              <i class="fas fa-chevron-down   cpointer"  ></i>
            </kendo-dropdownbutton>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Imagem" class="coluna_menor" [width]="110">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

          <img [src]="'/images/empresa/'+dataItem.imagens[0].linkImagem" style="width: 80px;" *ngIf="dataItem.imagens && dataItem.imagens.length > 0">

          <i class="fe-image fa-2x" *ngIf="!dataItem.imagens || dataItem.imagens.length == 0"></i>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Nome" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div class="product-name-cell">
            <button type="button"
                    class="btn btn-sm btn-light product-expand-btn"
                    [ngClass]="{'is-open': produtoComplementosExpandido(dataItem)}"
                    [attr.aria-expanded]="produtoComplementosExpandido(dataItem)"
                    [title]="produtoComplementosExpandido(dataItem) ? 'Ocultar adicionais' : 'Ver adicionais'"
                    (click)="toggleComplementosProduto(dataItem, $event)"
                    *ngIf="produtoTemComplementos(dataItem)">
              <i class="fas" [ngClass]="produtoComplementosExpandido(dataItem) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              <span class="product-expand-btn__count">{{quantidadeComplementosProduto(dataItem)}}</span>
            </button>

            <span class="product-name-cell__text"><b> <ng-container *ngIf="dataItem.codigoPdv">
               {{dataItem.codigoPdv}} - </ng-container> {{dataItem.nome}}</b></span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Preço"   [width]="100">
        <ng-template kendoGridCellTemplate let-produto let-rowIndex="rowIndex">

          <app-produto-preco
            [podeEditar]="podeEditarPrecos"
            [produto]="produto"
            [catalogo]="catalogo"
            [empresa]="empresa"
            [temModuloTabelaPrecos]="temModuloTabelaPrecos"
            (verPrecosClick)="abrirTabelaPrecosProduto($event)">
          </app-produto-preco>

        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Descrição" class="coluna_menor"   [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div class="abreviar">{{dataItem.descricao}}</div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Disponibilidade" class="coluna_menor" [width]="150" *ngIf="!abaProdutosExternos()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <ng-container *ngIf="dataItem.erroDisponivel  ">
            <div class="badge badge-danger text-break" >indisponivel </div>
            <p class="text-danger text-break">{{dataItem.erroDisponivel}}</p>
          </ng-container>

          <ng-container *ngIf="!disponibilidadePorEmpresa">
            <div class="badge badge-danger" *ngIf="dataItem.disponibilidade === 2">indisponível</div>
            <div class="badge badge-success" *ngIf="dataItem.disponibilidade === 0">sempre</div>
            <div class="badge badge-secondary" *ngIf="dataItem.disponibilidade === 3">oculto</div>
          </ng-container>
          <ng-container *ngIf="disponibilidadePorEmpresa">
            <div class="badge badge-danger" *ngIf="dataItem.disponibilidadeNaEmpresa === 2">indisponível</div>
            <div class="badge badge-success" *ngIf="dataItem.disponibilidadeNaEmpresa === 0">sempre</div>
            <div class="badge badge-secondary" *ngIf="dataItem.disponibilidade === 3">oculto</div>
          </ng-container>
          <ng-container *ngIf="dataItem.semDadosFiscais && possuiModuloFiscal">
            <br>
            <div class="badge badge-warning mt-1 text-break" >
              sem dados fiscais
            </div>

          </ng-container>

          <ng-container *ngIf="disponibilidadePorEmpresa ? dataItem.disponibilidadeNaEmpresa === 1 : dataItem.disponibilidade === 1">
            <div class="badge badge-blue mt-1 text-break" *ngFor="let disponibilidade of dataItem.disponibilidades">
              {{getDescricaoDisponibilidade(disponibilidade.id)}}
            </div>
          </ng-container>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="" [width]="160" [class]="{'comandos': true}">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-produto>
          <button kendoGridEditCommand [primary]="true" (selectedChange)="editarProduto(produto)">
            <i class="fa fa-edit" kendoTooltip title="editar"></i>
          </button>
          <button [disabled]="!podeEditarProdutos" kendoGridRemoveCommand kendoTooltip ><i
            kendoTooltip [title]="podeEditarProdutos ? 'Remover produto' : 'Remoção não permitida em cardápio compartilhado'"
            class="fa fa-trash"></i></button>

          <button class="btn btn-xs btn-danger ml-2" (click)="pausarVendasProduto(categoria, produto)"
                  kendoTooltip title="Parar Temporariamente a venda desse produto"
                  *ngIf="produto.estahDisponivel && !abaProdutosExternos()" [disabled]="processando || (!podeEditarProdutos && !catalogo.disponibilidadePorEmpresa)">
            <i class="far fa-pause-circle fa-lg">  </i>
          </button>
          <button class="btn btn-xs btn-primary ml-2" (click)="ativarVendasProduto(categoria, produto)"
                  kendoTooltip title="Ativar a venda desse produto" *ngIf="!produto.estahDisponivel && !abaProdutosExternos()"
                  [disabled]="processando || (!podeEditarProdutos && !catalogo.disponibilidadePorEmpresa)">
            <i class="far fa-play-circle fa-lg"  ></i>&nbsp;

          </button>

          <button class="k-button btn btn-sm  ml-2" (click)="clonarProduto( produto)"
                  *ngIf="!abaProdutosExternos()"
                  [disabled]="processando || !podeEditarProdutos">
            <i kendoTooltip class="fas fa-copy" [title]="podeEditarProdutos ? 'Clonar o produto' : 'Duplicar produto não é permitido em catálogo compartilhado'"></i>
          </button>
        </ng-template>
      </kendo-grid-command-column>

      <div class="k-i-loading ml-1 mr-1" style="font-size: 40px;height: 400px;" *ngIf="carregando"></div>

      <ng-template kendoGridDetailTemplate let-dataItem
        [kendoGridDetailTemplateShowIf]="mostrarComplementos.bind(this)">
        <div class="lista-complementos">
          <app-adicionais-produto [produto]="dataItem" [catalogo]="catalogo" [empresa]="empresa"></app-adicionais-produto>
        </div>
      </ng-template>
    </kendo-grid>
  </div>

  <kendo-datapager
    [style.width.%]="100"
    [pageSize]="pageSize"
    [skip]="skip"
    [total]="total" [pageSizeValues] = "pageSizes"
    (pageChange)="onPageChange($event)" *ngIf="total > 0">
  </kendo-datapager>
</div>

<div *ngIf="abaAlertaEstoque()">
  <div class="card-box"  >
    <h4 class="mb-3">Produtos com estoque próximo ou abaixo da <b>quantidade mínima</b></h4>
  </div>

  <kendo-grid
    (edit)="editarProduto($event)"
    [group]="groupsEstoque" [groupable]="true"
    [data]="produtosAlertaEstoqueGrid"
    [class]="'gridProdutos'"   >
    <kendo-grid-messages   pagerPage="Página"         pagerOf="de"
                           pagerItems="itens"  pagerItemsPerPage="ítems por página"  >
    </kendo-grid-messages>

    <kendo-grid-column field="nivelDescricao" [width]="0">
      <ng-template kendoGridGroupHeaderTemplate let-field="field" let-value="value">
        <strong>{{value}}</strong>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Codigo"  [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span><b>  {{dataItem.codigo || '-'}}</b></span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Nome"  [width]="220">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span class="text-blue"><b>  {{dataItem.nome}}</b></span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Tipo"  [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span><b>  {{dataItem.objeto}}</b></span>

        <span class="badge badge-info" *ngIf="dataItem.beneficiado">beneficiado</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Grupo"  [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span class="text-muted" >{{dataItem.grupo ? dataItem.grupo.nome : '-'}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Atual"    [width]="90" >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span [ngClass]="{'text-success': dataItem.nivelEstoque > 1.5,
                              'text-warning': dataItem.nivelEstoque <= 1.5 ,
                              'text-danger': dataItem.nivelEstoque < 1 }">
              <b> {{dataItem.estoque.quantidade}} {{dataItem.unidadeMedida.sigla}}</b></span>

        <i class="k-icon k-i-list-bulleted cpointer text-blue ml-1" (click)="abraModalMovimentacoes(dataItem)"
           style="    margin-top: -3px  " title="ver movimentações" kendoTooltip></i>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Minimo"    [width]="90">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <b>{{dataItem.estoque.quantidadeMinima}} {{dataItem.unidadeMedida.sigla}}</b>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="" [width]="70" [class]="{'comandos': true}">
      <ng-template kendoGridCellTemplate let-isNew="isNew" let-insumo>
        <button kendoGridEditCommand [primary]="true" >
          <i class="fa fa-edit" kendoTooltip title="editar"></i>
        </button>


      </ng-template>

    </kendo-grid-command-column>


  </kendo-grid>

</div>

<kendo-dialog title="Atenção!" *ngIf="abraDialogo" (close)="fechar()" [minWidth]="250" [width]="450">
  <div *ngIf="produtoSelecionado && !excluindoProduto">
    <p style="margin: 30px; text-align: center;">Esta operação é irreversível. Tem certeza que deseja excluir o produto "<strong>{{produtoSelecionado.nome}}?</strong>"</p>
  </div>
  <div *ngIf="excluindoProduto">
    <p style="margin: 30px; text-align: center;">Excluindo o produto "<strong>{{produtoSelecionado.nome}}"...</strong></p>
    <div class="k-i-loading ml-1 mr-1" style="font-size: 20px; padding-bottom: 20px  " ></div>
  </div>
  <div *ngIf="mensagemRemocao">
    <p style="margin: 30px; text-align: center;">{{mensagemRemocao}}</p>
  </div>

  <div class="modal-footer" *ngIf="!excluindoProduto">
    <button type="button" *ngIf="produtoSelecionado" (click)="removaProduto()" class="btn btn-primary waves-effect waves-light" >Remover</button>
    <button type="button" *ngIf="produtoSelecionado" (click)="fechar()" kendoButton [primary]="true"  class="btn btn-light waves-effect">Cancelar</button>
    <button type="button" *ngIf="!produtoSelecionado" (click)="fechar()" class="btn btn-primary waves-effect waves-light" >Fechar</button>
  </div>
</kendo-dialog>

<kendo-dialog title="Excluir produtos selecionados"
              *ngIf="dialogRemocaoProdutosLote"
              (close)="fecheRemocaoProdutosLote()"
              [minWidth]="320"
              [width]="520">
  <div class="bulk-remove-dialog">
    <div class="bulk-remove-dialog__icon">
      <i class="far fa-trash-alt"></i>
    </div>
    <div class="bulk-remove-dialog__content">
      <strong>{{totalProdutosSelecionadosLote}} produto(s) selecionado(s)</strong>
      <p *ngIf="!excluindoProdutosLote">
        Esta operação é irreversível. Os produtos selecionados serão removidos do catálogo.
      </p>
      <p *ngIf="excluindoProdutosLote">
        Removendo os produtos selecionados...
      </p>
      <div class="k-i-loading bulk-remove-dialog__loading" *ngIf="excluindoProdutosLote"></div>
      <div class="alert alert-danger mb-0" *ngIf="mensagemRemocaoProdutosLote">
        {{mensagemRemocaoProdutosLote}}
      </div>
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="fecheRemocaoProdutosLote()" [disabled]="excluindoProdutosLote">
      Cancelar
    </button>
    <button kendoButton
            [primary]="true"
            class="btn-danger"
            (click)="removaProdutosSelecionadosLote()"
            [disabled]="excluindoProdutosLote">
      Remover
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog [title]="tituloDisponibilidadeLote"
              *ngIf="dialogDisponibilidadeLote"
              (close)="fecheDisponibilidadeLote()"
              [minWidth]="320"
              [width]="720">
  <div class="bulk-availability-dialog">
    <div class="bulk-availability-target">
      <span>Alvo</span>
      <strong>{{descricaoAlvoDisponibilidadeLote}}</strong>
    </div>

    <div class="bulk-availability-options">
      <label class="bulk-availability-option"
             *ngFor="let disponibilidade of opcoesDisponibilidadeLote"
             [ngClass]="{'is-selected': disponibilidadeLote.disponibilidade === disponibilidade.id}">
        <input type="radio"
               name="disponibilidadeLote"
               [value]="disponibilidade.id"
               [(ngModel)]="disponibilidadeLote.disponibilidade"
               (ngModelChange)="onDisponibilidadeLoteChange()">
        <span>{{disponibilidade.descricao}}</span>
      </label>
    </div>

    <div class="bulk-availability-schedule"
         *ngIf="disponibilidadeLote.disponibilidade === 1 && !disponibilidadePorEmpresa">
      <app-view-disponibilidade #viewDisponibilidadesLote
                                [disponibilidades]="disponibilidadeLote.disponibilidades"
                                [catalogo]="catalogo">
      </app-view-disponibilidade>
    </div>

    <div class="bulk-availability-note"
         *ngIf="disponibilidadeLote.disponibilidade === 1 && disponibilidadePorEmpresa">
      Serão usados os horários já cadastrados em cada produto deste catálogo.
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="fecheDisponibilidadeLote()" [disabled]="processandoDisponibilidadeLote">
      Cancelar
    </button>
    <button kendoButton
            [primary]="true"
            (click)="apliqueDisponibilidadeLote()"
            [disabled]="!podeSalvarDisponibilidadeLote()">
      <span class="k-icon k-i-loading mr-1" *ngIf="processandoDisponibilidadeLote"></span>
      Aplicar
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog title="Confirme a Reordenação" *ngIf="confirmarReordenacao" (close)="respostaConfirmacaoReordenacao(false)" [minWidth]="250" [width]="'450px'">
  <p style="margin: 30px; text-align: center;">Confirma a reordenação de todos os  produtos do catálogo?</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="respostaConfirmacaoReordenacao(false)">Não</button>
    <button kendoButton (click)="respostaConfirmacaoReordenacao(true)" [primary]="true">Sim</button>
  </kendo-dialog-actions>
</kendo-dialog>
